import tochtApi from "../../../api/e-loket/tochtApi";
import tochtTypeApi from "../../../api/shared/tochtTypeApi";
import AccountApi from "../../../api/shared/accountApi";
import securityApi from "../../../api/shared/securityApi";

export default class VTTPerGemeentePageHelper {

	constructor(context, redirector) {
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const context = this.context;

		const params = context.props.match.params;
		const disabled = params.isDisabled || false;

		this.getAllByGemeente();
		this.getCurrentAccount();
		this.loadTochtTypes();

		const returnUrl = decodeURIComponent(context.props.match.params.returnUrl);

		context.setState({
			returnUrl,
			disabled
		});
	}

	onChangeOrganisation = (event) => {
		const ondernemingsnummer = event.target.value;
		const context = this.context;
		const props = context.props;
		const ajaxActions = props.ajaxActions;

		ajaxActions.started();
		securityApi.switchOrganisation(ondernemingsnummer)
			.then((response) => {
				ajaxActions.ended();
				props.loadAuthorizationInfo().then(() => {
					this.getAllByGemeente();
					this.getCurrentAccount();
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				props.throwException(ex);
			});
	};

	getAllByGemeente() {
		const ajaxActions = this.context.props.ajaxActions;
		ajaxActions.started();

		tochtApi.getAllByGemeente()
			.then((response) => {
				ajaxActions.ended();
				this.processModel(response, false);
			})
			.catch((ex) => {
				ajaxActions.failed();
				if (ex.response.status === 406) {
					this.context.props.throwException("Je hebt geen toegang tot deze pagina", true);
				}
				else {
					this.context.props.throwException(ex);
				}
			});
	}

	loadTochtTypes() {
		const ajaxActions = this.context.props.ajaxActions;
		ajaxActions.started();

		tochtTypeApi.getTochtTypes()
			.then((response) => {
				ajaxActions.ended();
				this.context.setState({
					tochtTypes: response.data
				});
			})
			.catch((ex) => {
				ajaxActions.failed();
				this.context.props.throwException(ex);
			});
	}

	getCurrentAccount() {
		const ajaxActions = this.context.props.ajaxActions;
		ajaxActions.started();

		AccountApi.getCurrentAccount()
			.then(response => {
				this.context.setState({
					account: response.data
				});
				ajaxActions.ended();
			}).catch(ex => {
				ajaxActions.failed();
				this.context.props.throwException(ex);
			});
	}

	updateTochtBehandelaar(event) {
		const tochtBehandelaarId = event.target.value;

		if (!tochtBehandelaarId) {
			return;
		}

		const ajaxActions = this.context.props.ajaxActions;
		ajaxActions.started();
		AccountApi.updateTochtBehandelaar(tochtBehandelaarId).then((response) => {
			this.context.setState({
				account: response.data
			});
			ajaxActions.ended();
		}).catch(ex => {
			ajaxActions.failed();
			this.context.props.throwException(ex);
		});
	}

	processModel(response) {
		const context = this.context;
		let model = response.data;

		context.setState({
			model
		});

		context.props.loadLayout();
	}
}
